'use client';

import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import classNames from 'classnames';
import { FC } from 'react';

interface NumberListingItemProps {
    id: string;
    title: string;
    count: string;
    length: number;
}

const NumberListingItem: FC<NumberListingItemProps> = ({ id, title, count, length }) => {
    const inspectorProps = useContentfulInspectorMode({ entryId: id });

    return (
        <div className="tw-text-center">
            <h2
                className={classNames(
                    'tw-inline-block tw-w-full  tw-text-[22px] md:tw-text-[36px] tw-h-[26px] md:tw-h-[43px]  tw-font-gotham-bold tw-text-[#003865] tw-mb-[4px]',
                    {
                        'max-sm:tw-text-[18px]': length > 3,
                    },
                )}
                {...inspectorProps({ fieldId: 'number' })}
            >
                {count}
            </h2>
            <p
                className={classNames(
                    'tw-text-[16px] tw-block  md:tw-text-[18px] tw-font-gotham-bold tw-text-[#4B4F54] tw-mb-[16px] tw-text-center',
                    {
                        'max-sm:tw-text-[12px]': length > 3,
                    },
                )}
                {...inspectorProps({ fieldId: 'content' })}
            >
                {title}
            </p>
        </div>
    );
};

export default NumberListingItem;
